function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { getPlatePluginType, getPlatePluginWithOverrides } from '@udecode/plate-core';
import { isDeserializerEnabled, insertDeserializedFragment } from '@udecode/plate-serializer';
import { ELEMENT_DEFAULT } from '@udecode/plate-common';
import { ELEMENT_TABLE, ELEMENT_TH, ELEMENT_TR, ELEMENT_TD } from '@udecode/plate-table';
import { parse } from 'papaparse';
var isValidCsv = function isValidCsv(data, errors, errorTolerance) {
  if (errorTolerance < 0) errorTolerance = 0;
  return !(!data || data.length < 2 || data[0].length < 2 || data[1].length < 2 || errors.length && errors.length > errorTolerance * data.length);
};
var deserializeCSV = function deserializeCSV(editor, content) {
  var header = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var errorTolerance = arguments.length > 3 ? arguments[3] : undefined;
  // Verify it's a csv string
  var testCsv = parse(content, {
    preview: 2
  });
  if (testCsv.errors.length === 0) {
    var csv = parse(content, {
      header: header
    });
    if (!isValidCsv(csv.data, csv.errors, errorTolerance)) return;
    var paragraph = getPlatePluginType(editor, ELEMENT_DEFAULT);
    var table = getPlatePluginType(editor, ELEMENT_TABLE);
    var th = getPlatePluginType(editor, ELEMENT_TH);
    var tr = getPlatePluginType(editor, ELEMENT_TR);
    var td = getPlatePluginType(editor, ELEMENT_TD);
    var ast = {
      type: table,
      children: []
    };
    if (csv.meta.fields) {
      // csv file has headers, data structure is an array of objects keyed on the heading title
      ast.children.push({
        type: tr,
        children: csv.meta.fields.map(function (field) {
          return {
            type: th,
            children: [{
              type: paragraph,
              children: [{
                text: field
              }]
            }]
          };
        })
      });
      var _iterator = _createForOfIteratorHelper(csv.data),
        _step;
      try {
        var _loop = function _loop() {
          var row = _step.value;
          ast.children.push({
            type: tr,
            children: csv.meta.fields.map(function (field) {
              return {
                type: td,
                children: [{
                  type: paragraph,
                  children: [{
                    text: row[field] || ''
                  }]
                }]
              };
            })
          });
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    } else {
      // csv is an array of arrays
      var _iterator2 = _createForOfIteratorHelper(csv.data),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var row = _step2.value;
          ast.children.push({
            type: tr,
            children: []
          });
          var _iterator3 = _createForOfIteratorHelper(row),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var cell = _step3.value;
              ast.children[ast.children.length - 1].children.push({
                type: td,
                children: [{
                  type: paragraph,
                  children: [{
                    text: cell
                  }]
                }]
              });
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    return [{
      type: paragraph,
      children: [{
        text: ''
      }]
    }, ast, {
      type: paragraph,
      children: [{
        text: ''
      }]
    }];
  }
};
var csvDeserializerId = 'CSV Deserializer';
/**
 * Enables support for deserializing content
 * from CSV format to Slate format.
 */

var withDeserializeCSV = function withDeserializeCSV() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$plugins = _ref.plugins,
    plugins = _ref$plugins === void 0 ? [] : _ref$plugins,
    _ref$errorTolerance = _ref.errorTolerance,
    errorTolerance = _ref$errorTolerance === void 0 ? 0.25 : _ref$errorTolerance;
  return function (editor) {
    var insertData = editor.insertData;
    editor.insertData = function (data) {
      var content = data.getData('text/plain');
      var isEnabled = isDeserializerEnabled(editor, plugins, csvDeserializerId);
      if (content && isEnabled) {
        var fragment = deserializeCSV(editor, content, true, errorTolerance);
        if (fragment !== null && fragment !== void 0 && fragment.length) {
          return insertDeserializedFragment(editor, {
            fragment: fragment,
            plugins: plugins
          });
        }
      }
      insertData(data);
    };
    return editor;
  };
};
/**
 * @see {@link withDeserializeCSV}
 */

var createDeserializeCSVPlugin = getPlatePluginWithOverrides(withDeserializeCSV);
export { createDeserializeCSVPlugin, csvDeserializerId, deserializeCSV, withDeserializeCSV };